import React from 'react'
import "./Widgets.css";

function Widgets() {
    return (
        <div className="widgets">
            <h3>CheckOut Videos On my Gaming Channel</h3>
            <iframe width="400" height="315" src="https://www.youtube.com/embed/5eMshuEUdfk" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowTransparency="true"
            allowfullscreen></iframe>

            <iframe width="400" height="315" src="https://www.youtube.com/embed/hL77pXA4Oio" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

            <iframe width="400" height="315" src="https://www.youtube.com/embed/GMmsCkQ12wQ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
           
        </div>
    )
}


export default Widgets
